import React from 'react';

interface SkeletonRowProps {
  columns: any[];
  style?: React.CSSProperties;
  trStyle?: React.CSSProperties;
}

const SkeletonRow: React.FC<SkeletonRowProps> = ({ columns, style, trStyle }) => (
  <tr style={trStyle}>
    {columns.map((_, index) => (
      <td key={index}>
        <div className="skeleton-loader" style={style} />
      </td>
    ))}
  </tr>
);

export default SkeletonRow;
